import { render, staticRenderFns } from "./draggable-sub-menu-new.vue?vue&type=template&id=562ec61c&"
import script from "./draggable-sub-menu-new.vue?vue&type=script&lang=js&"
export * from "./draggable-sub-menu-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "draggable-sub-menu-new.vue"
export default component.exports